import * as React from "react";
import styled from "styled-components";
import { BULK_SELECT_COLUMN_WIDTH, ROW_HEIGHT } from "../constants";
import { Checkbox } from "@hubper/core-ui/elements";
import useTable from "../../useTable";

const Base = styled.div<{ showShadow: boolean }>`
  width: ${BULK_SELECT_COLUMN_WIDTH}px;
  height: ${ROW_HEIGHT}px;
  padding: 12px;
  box-sizing: border-box;
  justify-content: flex-start;
  align-items: center;
  display: flex;
`;

type Props = {
  showShadow: boolean;
};

function BulkSelectHeaderCell({ showShadow }: Props) {
  const { rowColor2, selectedRows, onSelectedRowsChange, data } = useTable();

  return (
    <Base
      data-testid="bulk-select-header-cell"
      showShadow={showShadow}
      style={{ backgroundColor: rowColor2 }}
    >
      <Checkbox
        value={selectedRows!.length > 0}
        onClick={() => {
          if (selectedRows!.length > 0) {
            onSelectedRowsChange!([]);
          } else {
            onSelectedRowsChange!(data.map(row => row.id));
          }
        }}
      />
    </Base>
  );
}

export default BulkSelectHeaderCell;
